export const servicePrintStyle = `
        .print-empty-check { display: inline-block; width: 3mm; height: 3mm; border: 1px solid #000; vertical-align: middle; background: white; }
        .print-checked { line-height: 3mm; text-align: center; font-size: 10pt; font-weight: bold; color: #000; }
        .service-reception-sheet { margin-top: 24px; border-top: 2px solid #334155; padding-top: 16px; }
        .service-signatures { break-inside: avoid; }
        .service-command .print-totals { margin-bottom: 12px !important; }
        .service-command .print-footer { margin-top: 12px !important; }
        .service-command .print-footer .mt-5 { margin-top: 18px !important; }
        @page {
          size: A4 portrait;
          margin: 10mm !important;
        }
        @media print {
          .deviz-print, .deviz-print * {
            color: #000 !important;
            -webkit-text-fill-color: #000 !important;
            --bs-text-opacity: 1;
            opacity: 1 !important;
            text-shadow: none !important;
          }
          .service-reception-sheet { break-before: page; margin-top: 0; border: 0; padding-top: 5mm; }
          .service-command .mb-4 { margin-bottom: 10px !important; }
          .service-command .mb-5 { margin-bottom: 12px !important; }
          .service-command .reception-columns { gap: 14px; }
          .service-command .reception-columns td { padding: 3px 4px !important; font-size: 8pt !important; }
          html, body, #root, .app-layout {
            min-height: 0 !important;
            height: auto !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .app-layout > .pt-2 { display: none !important; }
          .deviz-print {
            page: auto;
            width: 100%;
            max-width: none;
            margin: 0;
            padding: 5mm !important;
            box-sizing: border-box;
            -webkit-box-decoration-break: clone;
            box-decoration-break: clone;
          }
          .deviz-print thead { display: table-header-group; }
          .deviz-print h6 { break-after: avoid; }
          .deviz-print th,
          .deviz-print td {
            min-width: 0 !important;
            max-width: none !important;
            white-space: normal !important;
            overflow-wrap: anywhere !important;
          }
          .deviz-print tr,
          .deviz-print .print-totals,
          .deviz-print .print-footer { break-inside: avoid; }
        }
      `;
